#import "../../templates/template-groups/graphql/fragments/email-sequence-template-full-fragment.graphql"

mutation CreateEmailSequenceTemplate($emailSequenceTemplate: EmailSequenceTemplateCreateInput!) {
    emailSequenceTemplateCreate(input: $emailSequenceTemplate) {
        emailSequenceTemplate {
            ...EmailSequenceTemplateFullFragment
        }
    }
}
